function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { assetPath, excerpt, translateFieldName, translate } from '../utils/helpers';
import { LANG } from '../utils/constant';
import NoImage from '../../../../assets/images/noImage.png';

var CartItem = /*#__PURE__*/function (_Component) {
  _inherits(CartItem, _Component);

  var _super = _createSuper(CartItem);

  function CartItem(props) {
    var _this;

    _classCallCheck(this, CartItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "updateQuantity", function (evt) {
      evt.preventDefault(); // evt.stopPropagation()

      _this.props.updateQuantity(_this.props.item.uniqId, parseInt(_this.quantityRef.current.value, 10));
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeQuantity", function (event) {
      var quantity = event.target.value; //return false if the value typed by user is not a number

      if (!event.target.validity.valid) {
        return false;
      } //return false if the value typed by user is superior to its max attribute


      if (parseInt(event.target.value, 10) > parseInt(event.target.max, 10)) {
        return false;
      }

      if (parseInt(event.target.value, 10) === 0) {
        quantity = 1;
      }

      _this.setState({
        quantity: quantity
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOutInput", function (event) {
      var quantity = parseInt(event.target.value);

      if (event.target.value === '') {
        quantity = _this.state.initialValue;
      } else {
        _this.props.updateQuantity(_this.props.item.uniqId, quantity);
      }

      _this.setState({
        quantity: quantity,
        initialValue: quantity
      });
    });

    _this.quantityRef = /*#__PURE__*/React.createRef();
    _this.state = {
      quantity: _this.props.item.quantity,
      initialValue: _this.props.item.quantity
    };
    return _this;
  }

  _createClass(CartItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var initialValue = this.state.quantity;
      this.setState({
        initialValue: initialValue
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          removeItem = _this$props.removeItem;
      var quantity = this.state.quantity; // const slugByName = convertStringToWPSlug(item[translateFieldName('name')])

      var assetImage = item.product_photos.length > 0 ? assetPath(item.product_photos[0].photo.thumb.url) : NoImage;
      return /*#__PURE__*/React.createElement("div", {
        className: "item-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "item-details"
      }, /*#__PURE__*/React.createElement("div", {
        className: "photo"
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/".concat(LANG, "/product/").concat(item.slug)
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          backgroundImage: 'url(' + assetImage + ')'
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "content-box"
      }, /*#__PURE__*/React.createElement("span", {
        className: "brand"
      }, item.supplier[translateFieldName('name')]), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/product/").concat(item.slug)
      }, /*#__PURE__*/React.createElement("span", {
        className: "title main-txt-hover"
      }, item[translateFieldName('name')])), /*#__PURE__*/React.createElement("span", {
        className: "code"
      }, /*#__PURE__*/React.createElement("span", null, item.selectedVariation.code ? /*#__PURE__*/React.createElement("div", null, item.selectedVariation.code.toUpperCase(), " ", /*#__PURE__*/React.createElement("span", null, "|")) : null), item.selectedVariation[translateFieldName('name')] !== '' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, item.selectedVariation[translateFieldName('name')])) : null))), /*#__PURE__*/React.createElement("div", {
        className: "item-description"
      }, /*#__PURE__*/React.createElement("span", {
        className: "description"
      }, excerpt(item[translateFieldName('description')], 150))), /*#__PURE__*/React.createElement("div", {
        className: "price-section"
      }, /*#__PURE__*/React.createElement("span", {
        className: "d-block d-sm-block d-md-none"
      }, translate('quantity', 'quantité').toUpperCase()), /*#__PURE__*/React.createElement("div", {
        className: "quantity"
      }, /*#__PURE__*/React.createElement("form", {
        onSubmit: this.updateQuantity
      }, /*#__PURE__*/React.createElement("input", {
        className: "input-qte",
        ref: this.quantityRef,
        type: "text",
        max: 10000,
        pattern: "[0-9]*",
        value: quantity,
        onChange: this.onChangeQuantity,
        onBlur: this.onOutInput
      })), /*#__PURE__*/React.createElement("div", {
        className: "remove main-txt",
        onClick: function onClick() {
          return removeItem(item.uniqId);
        }
      }, translate('remove', 'retirer')))));
    }
  }]);

  return CartItem;
}(Component);

CartItem.propTypes = {
  item: PropTypes.object,
  removeItem: PropTypes.func,
  updateQuantity: PropTypes.func
};
export default CartItem;